import Home from "../scenes/home";
import JoinLink from "../scenes/join-link";
import { INVITE_LINK_PATH } from "../utils/invite-link";

export const routes = [
  { path: "/", component: Home },
  { path: INVITE_LINK_PATH, component: JoinLink },
];
